import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../../LoadingSpinner';
import { Icon } from '@iconify/react';
import Notification from '../../Notification';

const ContactForm = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [copiedLink, setCopiedLink] = useState(null);
  const [notification, setNotification] = useState(null);

  const referralLinks = [
    { id: 1, url: "https://play.google.com/store/apps/details?id=com.zero.spcommunity&hl=en", label: "Our App link" },
    { id: 2, url: "https://wa.me/27789506051", label: "WhatsApp link" },
    { id: 3, url: "https://www.spcommunity.org.za/job-posts/", label: "Website Job Posts link" },
  ];

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []);

  const copyToClipboard = (url) => {
    navigator.clipboard.writeText(url);
    setCopiedLink(url);
    setNotification("Your link was copied, share it");

    setTimeout(() => {
      setNotification(null);
      setCopiedLink(null);
    }, 4000);
  };

  const handleShare = async () => {
    // Create the dynamic share text
    const shareText = `Check out these links from SP Community:\n\n` +
      referralLinks.map(link => `${link.label}: ${link.url}`).join('\n');
  
    if (navigator.share) {
      try {
        await navigator.share({
          title: "SP Community Links",
          text: shareText,  // Use dynamic share text here
          url: referralLinks[0].url, // You can choose any URL here, or leave it out
        });
        console.log("Sharing started");
      } catch (error) {
        console.error("Error sharing:", error);
        setNotification("Sharing was canceled or failed.");
      }
    } else {
      setNotification("Sharing not supported on this device.");
      // Fall back: copy link or show alternative options
    }
  };
  

  const linkStyle = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px",
    background: "#f8f9fa",
    borderRadius: "5px",
    cursor: "pointer",
    textDecoration: "none",
    color: "#007bff",
    width: "fit-content"
  };

  const shareButtonStyle = {
    marginTop: "20px",
    marginLeft: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    backgroundColor: "#28a745",
    color: "#fff",
    padding: "10px 16px",
    borderRadius: "5px",
    fontWeight: "bold",
  };

  return isLoading ? (
    <LoadingSpinner />
  ) : (
    <div>
      {notification && (
        <Notification message={notification} duration={4000} onClose={() => setNotification(null)} />
      )}

      {/* <div style={{ marginTop: "10px", marginLeft: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <strong>Share</strong>
      </div> */}

      {referralLinks.map((link) => (
        <div key={link.id} style={{ marginTop: "10px", marginLeft: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <div onClick={() => copyToClipboard(link.url)} style={linkStyle}>
            <strong>{link.label}</strong>
            {copiedLink === link.url ? (
              <Icon icon="solar:copy-bold-duotone" width="20" height="20" />
            ) : (
              <Icon icon="solar:copy-line-duotone" width="20" height="20" />
            )}
          </div>
        </div>
      ))}
      {/*}
      <div style={{ marginTop: "10px", marginLeft: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>OR</div>

       Share via Android Apps 
      <div style={shareButtonStyle} onClick={handleShare}>
        <Icon icon="mdi:share-variant" width="20" height="20" style={{ marginRight: "8px" }} />
        Share with Apps
      </div>
      */}
    </div>
  );
};

export default ContactForm;
